// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Other Components

// Management
const LeadGroupList = () => import('@/modules/lead_groups/views/management/LeadGroupList')

var routes = [
    {
        path: '/lead-groups/manage',
        redirect: '/lead-groups/manage/list',
        component: DefaultContainer,
        children: [
            {
                path: 'list',
                name: 'LeadGroupList',
                component: LeadGroupList,
            },
        ]
    },
];

export default routes;
